module.exports = __webpack_public_path__ + "img/icon-5-green.fa287fc8.svg";